/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { canvasCssValue } from '@lib/canvasx/util';
import { Rect } from '@lib/canvasx/components/Rect';
import { SPACER_2 } from '../utils/style';

const CardDivider: CanvaSXFC<{ width: number }> = function ({ width }) {
  const borderColor = canvasCssValue('--theme-primary-border', '#e1e1e1');

  return (
    <Rect margin={{ vertical: SPACER_2 }}>
      <Rect height={1} width={width} fill={borderColor} />
    </Rect>
  );
};

export default CardDivider;
